import React from 'react'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { ResetFilters, SelectedFilters } from 'searchkit'
import FilterV2Box from '../catalog/FilterV2Box'
import * as transforms from '../catalog/filterTransforms'
import { ClearFiltersDesktop, CustomFilterItem } from '../catalog/filterComponents'
import { getSelectedCenter } from '../../store/centers/reducers'
import { hasImperialUnits } from '../../helpers'

/**
 * Filtros de la landing de campañas (plantilla 2). Son los mismos FilterV2Box del catálogo, con las
 * mismas transformaciones de buckets, pero sin las variantes de Mktools/Ikea/Lowes ni los gates por
 * tipo de usuario: en una campaña solo hay tablas, y el destinatario siempre es cliente final.
 *
 * Tiene que renderizarse dentro de un <SearchkitProvider>.
 */
class PromotionFilters extends React.Component {
    render() {
        const { intl } = this.props

        const filters = [
            <FilterV2Box
                filteredDataName="brand"
                translatedTitle={intl.formatMessage({ id: 'brands' })}
                onTransform={filters => transforms.brandTransform(filters, this.props.selectedCenter)}
            />,
            <FilterV2Box
                filteredDataName="thickness"
                translatedTitle={intl.formatMessage({ id: 'thickness' })}
                onTransform={transforms.thicknessTransform}
                size={5}
            />,
            <FilterV2Box
                filteredDataName="finish"
                translatedTitle={intl.formatMessage({ id: 'finish' })}
                onTransform={filters => transforms.finishTransform(filters, intl)}
            />,
            <FilterV2Box
                filteredDataName="finishFamily"
                translatedTitle={intl.formatMessage({ id: 'finishFamily' })}
                onTransform={filters => transforms.finishTransform(filters, intl)}
            />,
            <FilterV2Box
                filteredDataName={transforms.getCommercialFormatFieldName(intl.locale)}
                translatedTitle={intl.formatMessage({ id: 'format' })}
                onTransform={filters => transforms.commercialFormatTransform(filters, this.props.hasImperialUnits)}
                size={5}
            />,
            <FilterV2Box
                filteredDataName="colorSerieDesc"
                translatedTitle={intl.formatMessage({ id: 'collection' })}
                onTransform={transforms.colorSerieDescTransform}
                size={5}
            />,
            <FilterV2Box
                filteredDataName="tone"
                translatedTitle={intl.formatMessage({ id: 'tone' })}
                onTransform={filters => transforms.toneTransform(filters, intl)}
                size={5}
            />,
            <FilterV2Box
                filteredDataName="zaddon"
                translatedTitle={intl.formatMessage({ id: 'MAL' })}
                onTransform={transforms.zaddonTransform}
                size={5}
                operator="AND"
            />,
            <FilterV2Box
                filteredDataName="family"
                translatedTitle={intl.formatMessage({ id: 'stone_families', defaultMessage: 'Stone families' })}
                onTransform={filters => transforms.familyTransform(filters, intl)}
            />
        ]

        return (
            <div className="filter-container promotion-landing-filters">
                <div className="catalog__group_filters_options">
                    <div className="filters">
                        <div className="filters__contain">
                            <div className="first-line">
                                <div className="filter-content">
                                    <div className="filter-items">
                                        <div className="filter-items--child">
                                            {filters.map((filter, index) => (
                                                <div key={index} className="filter-item">
                                                    {filter}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="tags_clean">
                            <SelectedFilters itemComponent={CustomFilterItem(this.props.hasImperialUnits, this.props.intl)} />
                            <ResetFilters component={<ClearFiltersDesktop onReset={() => {}} />} />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        selectedCenter: getSelectedCenter(state),
        hasImperialUnits: hasImperialUnits(state)
    }
}

export default injectIntl(connect(mapStateToProps)(PromotionFilters))
